export const shouldFetch = webContentUrl => webContentUrl != null;
